var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-app"},[_c('h2',{staticClass:"app-title"},[_vm._v("Definições do Robô")]),_c('div',{staticClass:"m-t-lg"},[_c('u-btn',{attrs:{"label":!_vm.backgroundEnabled ? 'Forçar execução do Robô Leiloeiro' : 'Parar exeução forçada do Robô',"no-caps":"","color":"green"},on:{"click":_vm.forceBackground}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }